!function (e, i) {
  "object" == typeof exports && "object" == typeof module ? module.exports = i(require("highlight.js/lib/core"), require("highlight.js/lib/languages/bash"), require("highlight.js/lib/languages/cpp"), require("highlight.js/lib/languages/csharp"), require("highlight.js/lib/languages/css"), require("highlight.js/lib/languages/dart"), require("highlight.js/lib/languages/diff"), require("highlight.js/lib/languages/dos"), require("highlight.js/lib/languages/elixir"), require("highlight.js/lib/languages/erlang"), require("highlight.js/lib/languages/go"), require("highlight.js/lib/languages/http"), require("highlight.js/lib/languages/java"), require("highlight.js/lib/languages/javascript"), require("highlight.js/lib/languages/json"), require("highlight.js/lib/languages/kotlin"), require("highlight.js/lib/languages/objectivec"), require("highlight.js/lib/languages/php"), require("highlight.js/lib/languages/plaintext"), require("highlight.js/lib/languages/python"), require("highlight.js/lib/languages/ruby"), require("highlight.js/lib/languages/sql"), require("highlight.js/lib/languages/swift"), require("highlight.js/lib/languages/typescript"), require("highlight.js/lib/languages/xml"), require("highlight.js/lib/languages/yaml"), require("highlightjs-curl/src/languages/curl")) : "function" == typeof define && define.amd ? define([,,,,,,,,,,,,,,,,,,,,,,,,,,], i) : "object" == typeof exports ? exports.AblyUi = i(require("highlight.js/lib/core"), require("highlight.js/lib/languages/bash"), require("highlight.js/lib/languages/cpp"), require("highlight.js/lib/languages/csharp"), require("highlight.js/lib/languages/css"), require("highlight.js/lib/languages/dart"), require("highlight.js/lib/languages/diff"), require("highlight.js/lib/languages/dos"), require("highlight.js/lib/languages/elixir"), require("highlight.js/lib/languages/erlang"), require("highlight.js/lib/languages/go"), require("highlight.js/lib/languages/http"), require("highlight.js/lib/languages/java"), require("highlight.js/lib/languages/javascript"), require("highlight.js/lib/languages/json"), require("highlight.js/lib/languages/kotlin"), require("highlight.js/lib/languages/objectivec"), require("highlight.js/lib/languages/php"), require("highlight.js/lib/languages/plaintext"), require("highlight.js/lib/languages/python"), require("highlight.js/lib/languages/ruby"), require("highlight.js/lib/languages/sql"), require("highlight.js/lib/languages/swift"), require("highlight.js/lib/languages/typescript"), require("highlight.js/lib/languages/xml"), require("highlight.js/lib/languages/yaml"), require("highlightjs-curl/src/languages/curl")) : (e.AblyUi = e.AblyUi || {}, e.AblyUi.Core = e.AblyUi.Core || {}, e.AblyUi.Core.Code = i(e[void 0], e[void 0], e[void 0], e[void 0], e[void 0], e[void 0], e[void 0], e[void 0], e[void 0], e[void 0], e[void 0], e[void 0], e[void 0], e[void 0], e[void 0], e[void 0], e[void 0], e[void 0], e[void 0], e[void 0], e[void 0], e[void 0], e[void 0], e[void 0], e[void 0], e[void 0], e[void 0]));
}(this, (e, i, l, a, r, g, s, t, h, u, o, n, b, c, d, p, j, y, q, v, x, k, m, f, S, L, w) => (() => {
  "use strict";

  var C = {
      9302: i => {
        i.exports = e;
      },
      497: e => {
        e.exports = i;
      },
      6736: e => {
        e.exports = l;
      },
      4260: e => {
        e.exports = a;
      },
      7892: e => {
        e.exports = r;
      },
      8673: e => {
        e.exports = g;
      },
      3523: e => {
        e.exports = s;
      },
      9857: e => {
        e.exports = t;
      },
      2870: e => {
        e.exports = h;
      },
      5964: e => {
        e.exports = u;
      },
      3345: e => {
        e.exports = o;
      },
      132: e => {
        e.exports = n;
      },
      314: e => {
        e.exports = b;
      },
      6257: e => {
        e.exports = c;
      },
      5114: e => {
        e.exports = d;
      },
      6482: e => {
        e.exports = p;
      },
      2519: e => {
        e.exports = j;
      },
      1703: e => {
        e.exports = y;
      },
      7420: e => {
        e.exports = q;
      },
      6941: e => {
        e.exports = v;
      },
      7684: e => {
        e.exports = x;
      },
      5501: e => {
        e.exports = k;
      },
      5098: e => {
        e.exports = m;
      },
      9937: e => {
        e.exports = f;
      },
      6630: e => {
        e.exports = S;
      },
      1469: e => {
        e.exports = L;
      },
      8488: e => {
        e.exports = w;
      }
    },
    M = {};
  function A(e) {
    var i = M[e];
    if (void 0 !== i) return i.exports;
    var l = M[e] = {
      exports: {}
    };
    return C[e](l, l.exports, A), l.exports;
  }
  A.n = e => {
    var i = e && e.__esModule ? () => e.default : () => e;
    return A.d(i, {
      a: i
    }), i;
  }, A.d = (e, i) => {
    for (var l in i) A.o(i, l) && !A.o(e, l) && Object.defineProperty(e, l, {
      enumerable: !0,
      get: i[l]
    });
  }, A.o = (e, i) => Object.prototype.hasOwnProperty.call(e, i);
  var T = {};
  return (() => {
    A.d(T, {
      default: () => le
    });
    var e = A(9302),
      i = A.n(e),
      l = A(497),
      a = A.n(l),
      r = A(6736),
      g = A.n(r),
      s = A(4260),
      t = A.n(s),
      h = A(7892),
      u = A.n(h),
      o = A(8673),
      n = A.n(o),
      b = A(9857),
      c = A.n(b),
      d = A(3523),
      p = A.n(d),
      j = A(5964),
      y = A.n(j),
      q = A(2870),
      v = A.n(q),
      x = A(7420),
      k = A.n(x),
      m = A(3345),
      f = A.n(m),
      S = A(132),
      L = A.n(S),
      w = A(314),
      C = A.n(w),
      M = A(6257),
      U = A.n(M),
      H = A(9937),
      O = A.n(H),
      P = A(5114),
      D = A.n(P),
      E = A(2519),
      J = A.n(E),
      N = A(1703),
      R = A.n(N),
      _ = A(6941),
      G = A.n(_),
      K = A(7684),
      Q = A.n(K),
      X = A(5098),
      Y = A.n(X),
      z = A(6482),
      B = A.n(z),
      F = A(5501),
      I = A.n(F),
      V = A(6630),
      W = A.n(V),
      Z = A(1469),
      $ = A.n(Z),
      ee = A(8488),
      ie = A.n(ee);
    [{
      label: "Text",
      key: "text",
      module: k()
    }, {
      label: "JS",
      key: "javascript",
      module: U()
    }, {
      label: "TS",
      key: "typescript",
      module: O()
    }, {
      label: "Java",
      key: "java",
      module: C()
    }, {
      label: "Ruby",
      key: "ruby",
      module: Q()
    }, {
      label: "Python",
      key: "python",
      module: G()
    }, {
      label: "PHP",
      key: "php",
      module: R()
    }, {
      label: "Shell",
      key: "bash",
      module: a()
    }, {
      label: "C#",
      key: "cs",
      module: t()
    }, {
      label: "CSS",
      key: "css",
      module: u()
    }, {
      label: "Go",
      key: "go",
      module: f()
    }, {
      label: "HTML",
      key: "xml",
      module: W()
    }, {
      label: "HTTP",
      key: "http",
      module: L()
    }, {
      label: "C++",
      key: "cpp",
      module: g()
    }, {
      label: "Dart",
      key: "dart",
      module: n()
    }, {
      label: "Swift",
      key: "swift",
      module: Y()
    }, {
      label: "Kotlin",
      key: "kotlin",
      module: B()
    }, {
      label: "Objective C",
      key: "objectivec",
      module: J()
    }, {
      label: "Node.js",
      key: "javascript",
      module: U()
    }, {
      label: "JSON",
      key: "json",
      module: D()
    }, {
      label: "DOS",
      key: "dos",
      module: c()
    }, {
      label: "YAML",
      key: "yaml",
      module: $()
    }, {
      label: "Erlang",
      key: "erlang",
      module: y()
    }, {
      label: "Elixir",
      key: "elixir",
      module: v()
    }, {
      label: "Diff",
      key: "diff",
      module: p()
    }, {
      label: "SQL",
      key: "sql",
      module: I()
    }, {
      label: "cURL",
      key: "curl",
      module: ie()
    }, {
      label: "HTML",
      key: "html",
      module: W()
    }, {
      label: "XML",
      key: "xml",
      module: W()
    }].forEach(function (e) {
      var l = e.key,
        a = e.module;
      return i().registerLanguage(l, a);
    });
    const le = function (e) {
      if (!e) throw "Missing code element";
      var l = e.querySelector("pre"),
        a = e.querySelector("code"),
        r = l.getAttribute("lang");
      if (!a || !l || !r) throw "Malformed code element";
      var g = function (e, l) {
        var a = function (e) {
          var i;
          switch (e || (e = "text"), e.toLowerCase()) {
            case "android":
              i = "java";
              break;
            case ".net":
            case "net":
            case "dotnet":
            case "csharp":
            case "c#":
              i = "cs";
              break;
            case "objc":
            case "objective c":
              i = "objectivec";
              break;
            case "laravel":
              i = "php";
              break;
            case "flutter":
              i = "dart";
              break;
            case "node.js":
            case "js":
              i = "javascript";
              break;
            case "ts":
              i = "typescript";
              break;
            case "kotlin":
            case "kt":
              i = "kotlin";
              break;
            case "shell":
            case "fh":
            case "sh":
              i = "bash";
              break;
            case "https":
            case "http":
            case "txt":
            case "plaintext":
              i = "text";
              break;
            case "cmd":
            case "bat":
              i = "dos";
              break;
            case "yml":
              i = "yaml";
              break;
            case "erl":
              i = "erlang";
              break;
            case "patch":
              i = "diff";
              break;
            case "svg":
              i = "xml";
          }
          return i || e;
        }(e);
        if ("string" == typeof l && l && a) return i().highlight(l, {
          language: a
        }).value;
      }(r, a.innerHTML);
      a.innerHTML = g;
    };
  })(), T.default;
})());